/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-31 10:47:12
 */
import { API_PREFIX } from "./constant";
import { Request } from "./request";
import { SupplierCategory } from "../models/enums"

export interface supplierParams {
    current?: number,
    size?: number,
    supplierCategory?: SupplierCategory,
    name?: string,
    flag?: number,
}

export interface supplierSubmitBody {
    address: string,
    companyName: string,
    licenceCategory: string,
    licenceDeadline: string,
    licenceNumber: string,
    mnemonicCode: string,
    phone: string,
    supplierMaterialsCategory: string,
    supplierCategory: number
    companyCode?: string,
    fax?: string,
    postCode?: string,
    id?: number
}

export function supplierPage(
    params: supplierParams
): Request {
    return {
        url: `${API_PREFIX}/blade-store/supplier/page`,
        method: "GET",
        params
    }
}

export function supplierDetail(
    id: number
): Request {
    return {
        url: `${API_PREFIX}/blade-store/supplier/detail`,
        method: "GET",
        params: {
            id
        }
    }
}

export function supplierSubmit(
    body: supplierSubmitBody
): Request {
    return {
        url: `${API_PREFIX}/blade-store/supplier/submit`,
        method: "POST",
        body
    }
}
